import React from 'react';
import styles from './Loading.scss';

const Loading = ({centered = true, color = ''}) => {

	return (
	  <div
		className={`${styles.container} ${centered ? styles.centered : ''} ${color ? styles[color] : ''}`}
		role="status"
		aria-live="polite"
		aria-label="Loading...">
		  {Array.from({length: 6}).map((_, index) => (
			<div key={index} className={styles.dot}/>
		  ))}
	  </div>
	);
};

export default Loading;